import React from 'react';
import { useMount } from '@shared/utils/hooks/useMount';

import { useEventDisplayName } from '@shared/utils/eventInfo/useEventDisplayName';
import { CarRentalConsoleWithHealth } from '@apps/stays/CarRentalConsole/CarRentalConsole';
import { usePreloadTranslationNamespaces } from '@shared/hooks/usePreloadTranslationNamespaces';
import { useHotelBookingRedirectHealth, wrapWithHotelBookingRedirectProvider } from '../../HotelBooking.health';

export const GuestCarSearch = wrapWithHotelBookingRedirectProvider(({ eventHandle }: { eventHandle: string }) => {
  const { onLoadComplete } = useHotelBookingRedirectHealth();
  const eventDisplayName = useEventDisplayName();

  usePreloadTranslationNamespaces('carRentalConsole');

  useMount(() => {
    onLoadComplete();
  });

  return (
    <CarRentalConsoleWithHealth
      eventHandle={eventHandle}
      eventName={eventDisplayName}
    />
  );
});
